import React from 'react';
import PropTypes from 'prop-types';
import { Row } from 'react-bootstrap';
const uuid = require('uuid');
import { withRouter } from 'react-router-dom'

const ProjectStore = require('../../stores/ProjectStore');
const ChannelStore = require('../../stores/channel_store_reflux');
const OrganizationMemberStore = require('../../stores/OrganizationMemberStore');
const OrganizationActions = require('../../actions/OrganizationActions');
const CollaboratorActions = require('../../actions/CollaboratorActions');
const PermissionsUtil = require('../../../../app/shared/PermissionsUtil');
const Globals = require('../../../../app/globals');
import Navigator from '../../Navigator';
import MainNav from '../DashboardNew/Menu/MainNav';
import SubNav from '../nav/SubNav';
import BackButton from '../nav/BackButton';
import ProjectCollaborators from './ProjectCollaborators'

const propTypes = {
    history: PropTypes.object.isRequired,
    match: PropTypes.shape({
        params: PropTypes.object.isRequired,
    }).isRequired,
};

const defaultProps = {

};

class ProjectCollaboratorsView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            channelStoreState: ChannelStore.getStateChannel(this.props.match.params.channel),
            projectStoreState: ProjectStore.getStateProject(this.props.match.params.projectID),
            organizationMemberStoreState: OrganizationMemberStore.getState(),
        };

        this.checkPathExists = this.checkPathExists.bind(this);
        this.checkToGetProjectCollabs = this.checkToGetProjectCollabs.bind(this);
        this.checkToGetOrgCollabs = this.checkToGetOrgCollabs.bind(this);
        this.backHandler = this.backHandler.bind(this);
        this._getProject = this._getProject.bind(this);

        this.unsubscribes = [
            ProjectStore.listen(this.onProjectStoreChange.bind(this)),
            ChannelStore.listen(this.onChannelStoreChange.bind(this)),
            OrganizationMemberStore.listen(this.onOrganizationMemberStoreChange.bind(this)),
        ];
    }

    componentDidMount() {
        if (!this.checkPathExists(this.state.channelStoreState, this.state.projectStoreState)) {
            return;
        }

        if (!this.checkToGetProjectCollabs(this.state.channelStoreState, this.state.projectStoreState)) {
            return;
        }

        this.checkToGetOrgCollabs(this.state.channelStoreState, this.state.projectStoreState);
    }

    componentWillUnmount() {
        this.unsubscribes.forEach(unsubscribeCallback => { unsubscribeCallback(); });
    }

    onProjectStoreChange(state) {
        const newProjectStoreState = ProjectStore.getStateProject(this.props.match.params.projectID);
        if (!this.checkPathExists(this.state.channelStoreState, newProjectStoreState)) {
            return;
        }

        if (!this.checkToGetProjectCollabs(this.state.channelStoreState, newProjectStoreState)) {
            return;
        }

        this.checkToGetOrgCollabs(this.state.channelStoreState, newProjectStoreState);
        this.setState({ projectStoreState: newProjectStoreState });
    }

    onChannelStoreChange(state) {
        const newChannelStoreState = ChannelStore.getStateChannel(this.props.match.params.channel)
        if (!this.checkPathExists(newChannelStoreState, this.state.projectStoreState)) {
            return;
        }

        if (!this.checkToGetProjectCollabs(newChannelStoreState, this.state.projectStoreState)) {
            return;
        }

        this.checkToGetOrgCollabs(newChannelStoreState, this.state.projectStoreState);
        this.setState({ channelStoreState: newChannelStoreState });
    }

    onOrganizationMemberStoreChange(state) {
        this.setState({ organizationMemberStoreState: state });
    }

    checkPathExists(channelStoreState, projectStoreState) {
        if (channelStoreState.initialized && !channelStoreState.channel) {
            Navigator.goToDashboardAuthorView(this.props.history, Globals.view_tokens.dashboard.AUTHORING);
            return false;
        }

        if (projectStoreState.initialized && !this._getProject(projectStoreState)) {
            Navigator.goToDashboardAuthorAuthoringChannelView(this.props.history, channelStoreState.channel.id);
            return false;
        }

        return true;
    }

    checkToGetProjectCollabs(channelStoreState, projectStoreState) {
        if (channelStoreState.initialized && projectStoreState.initialized) {
            const project = this._getProject(projectStoreState);
            if (
                !channelStoreState.channel
                || !project
                || !PermissionsUtil.canViewProjectCollaborators(
                    project.user_permissions,
                    channelStoreState.channel.user_permissions
                )) {
                this.backHandler();
                return false;
            }

            CollaboratorActions.getProjectCollabs(uuid.v4(), { projectID: this.props.match.params.projectID });
            return true;
        }

        return true;
    }

    checkToGetOrgCollabs(channelStoreState, projectStoreState) {
        if (channelStoreState.initialized && projectStoreState.initialized) {
            const project = this._getProject(projectStoreState);
            const channel = channelStoreState.channel;

            if (!channel ||
                !project ||
                !Globals.users.is_org_account_type(channel.channel_account_type_token) ||
                !PermissionsUtil.canEditProjectCollaborators(channel.user_permissions, project.user_permissions) ||
                !PermissionsUtil.canViewOrgMembers(channel.user_permissions)) {
                return;
            }

            OrganizationActions.getMembers(uuid.v4(), { id: parseInt(this.props.match.params.channel) });
        }
    }

    backHandler() {
        Navigator.goToProjectView(this.props.history, this.props.match.params.channel, this.props.match.params.projectID);
    }

    _getProject(projectStoreState) {
        return projectStoreState.project || projectStoreState.shortCourseProject;
    }

    render() {
        const self = this;
        let projectName = '';
        let canEditCollabs = false;
        let isOrgProject = false;
        let orgPossibleCollaborators = [];
        let channelUserPermissions = {};
        if (this.state.channelStoreState.initialized && this.state.projectStoreState.initialized) {
            const project = this._getProject(this.state.projectStoreState);
            const channel = this.state.channelStoreState.channel;
            channelUserPermissions = channel.user_permissions;
            canEditCollabs = PermissionsUtil.canEditProjectCollaborators(channel.user_permissions, project.user_permissions);
            isOrgProject = Globals.users.is_org_account_type(channel.channel_account_type_token);
            if (isOrgProject) {
                orgPossibleCollaborators = this.state.organizationMemberStoreState.members[channel.id];
            }

            projectName = project.name;
        }

        return (
            <div>
                <MainNav
                    onClickBrandLogo={() => Navigator.goToDashboardAuthorAuthoringChannelView(this.props.history, this.props.match.params.channel)}
                />

                <div className="container main-container">
                    <SubNav menuClasses= "d-inline-block d-sm-none">
                        <BackButton backHandler={this.backHandler} />
                        <div className="view-info-container">
                            <div className="view-title">
                                {projectName}
                            </div>
                            <div className="view-description">
                                Project Collaborators
                            </div>
                        </div>
                    </SubNav>


                    <Row className="main-content-nav">
                        <div className="main-content col-12">
                            <ProjectCollaborators
                                projectId={this.props.match.params.projectID}
                                canEdit={canEditCollabs}
                                isOrgProject={isOrgProject}
                                canViewOrgMembers={PermissionsUtil.canViewOrgMembers(channelUserPermissions)}
                                orgPossibleCollaborators={orgPossibleCollaborators}
                            />
                        </div>
                    </Row>
                </div>
            </div>
        );
    }
}

ProjectCollaboratorsView.propTypes = propTypes;
ProjectCollaboratorsView.defaultProps = defaultProps;

export default withRouter(ProjectCollaboratorsView);
